import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Card from 'react-bootstrap/Card';
import { ScrollContainer } from 'react-nice-scroll';
import { ListGroup } from 'react-bootstrap';
import { fetchAlertsList } from 'services/modules/vapt/alert';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/system';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .MuiTooltip-tooltip {
    font-size: 0.9em; 
  }
`;

const UploadedVulnerabilities = (props) => {
  // React router
  const navigate = useNavigate();
  // Props
  const domain = props.domain;
  const date = props.date;
  // State variables
  const [criticalThreats, setCriticalThreats] = useState([]);
  
  // Fetches existing vulnerabilities based on domain and date
  useEffect(() => {
    const fetchThreatActors = async () => {
      const params = { domain: domain, date: date, sortBy: '-createdAt' };
      const response = await fetchAlertsList({ params });
      if (response?.status === 200 || response.status === 201)
        setCriticalThreats(response?.data?.results);
    };
    if (domain !== null && date !== null) {
      fetchThreatActors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handles navigation to individual alert page
  function show(threat) {
    navigate(`/vapt/edit-vulnerability/${threat.id}`);
  }

  return (
    <div>
      <ScrollContainer className="topalerts">
        <Card className="text-white rounded-10 topalerts">
          <Card.Body>
            <Card.Title>
              <div className="carousel-title text-white"> Submitted Vulnerabilities </div>
            </Card.Title>
            <Card.Text>
              <div className="topalerts-div">
                <div>
                  {!criticalThreats || criticalThreats?.length === 0 ? (
                    <span className="text-h8 text-center text-tertiary">
                      No findings found
                    </span>
                  ) : null}
                  {criticalThreats && criticalThreats.length > 0 ? (
                    <ListGroup className="topalerts-listgroup">
                      {criticalThreats.map((threat, index) => (
                        <div key={index}>
                          <ListGroup.Item action onClick={() => show(threat)}>
                            <div className="d-flex justify-content-between">
                              <CustomTooltip
                                title={
                                  <React.Fragment>
                                    <div>{`Subdimension: ${threat?.dimension?.label}`}</div>
                                    <div>{`Severity: ${threat?.severity}`}</div>
                                  </React.Fragment>
                                }
                              >
                                <span style={{fontSize:'0.9rem'}}>{threat.title}</span>
                              </CustomTooltip>
                            </div>
                          </ListGroup.Item>
                        </div>
                      ))}
                    </ListGroup>
                  ) : (
                    <div className="mt-3">
                      <hr className="my-2" />
                    </div>
                  )}
                </div>
              </div>
            </Card.Text>
          </Card.Body>
        </Card>
      </ScrollContainer>
    </div>
  );
};

export default UploadedVulnerabilities;
